import React from 'react';
import styled from 'styled-components';
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
}

var attributes = {
  borderRadius: {
    extraSmall: 2,
    small: 5,
    default: 10,
    big: 20
  },
  boxShadow: {
    small: '0 0 46px 0 rgba(0, 0, 0, 0.13)',
    hover: '0 0 15px 0 rgba(0, 0, 0, 0.13)',
    buttonHover: '0 1px 5px rgba(0, 0, 0, 0.35)',
    buttonActive: 'inset 0 0px 5px rgba(0, 0, 0, 0.15)',
    iconButtonHover: '0 1px 8px rgba(0, 0, 0, 0.35)',
    layoutShadowInset: 'inset 0 -1px 0 rgba(0, 0, 0, 0.15)',
    layoutShadow: '0 1px 0 rgba(0, 0, 0, 0.15)',
    stepperShadow: '0px -5px 20px rgba(0, 0, 0, 0.04), 0px -2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)',
    highlightBoxShadow: '0 2px 5px 0 rgba(7,52,99,0.15)'
  },
  zIndex: {
    modal: 5,
    footer: 4,
    high: 3,
    middle: 2,
    low: 1
  },
  transition: {
    t1: '550ms cubic-bezier(0.19, 1, 0.22, 1)',
    inputTransition: 'box-shadow 250ms ease'
  }
};
var breakpoints = {
  xxs: 360,
  xs: 480,
  sm: 576,
  md: 768,
  lg: 960,
  xl: 1060,
  xxl: 1280,
  xxxl: 1400
};
var constants = {
  headerScrollFadeRange: 50,
  modalContainerMaxWidth: 615,
  modalConfirmMaxWidth: 480,
  pageContainerMaxWidth: 776,
  twoColumnsContainerMaxWidth: 1024,
  deliverySlotItemWidth: 130,
  deliverySlotItemWidthDesktop: 146,
  deliverySlotItemHeight: 91,
  deliverySlotArrowOffset: 42,
  itemGap: 2,
  listImageMaxWidth: 64,
  listImageMaxHeight: 50,
  listImageMaxWidthSmall: 32,
  listImageMaxHeightSmall: 32,
  listItemFlexGap: 20,
  infoBlockImageMaxWidthDesktop: 100,
  chipCheckBox: 12,
  pageContentMaxWidth: 1232,
  infoBlockBorderWidth: 4,
  tableRowVerticalPadding: 16,
  tableRowHorizontalPadding: 14,
  tableHeaderVerticalPadding: 12,
  menuHorizontalMargin: 12,
  headerWrapperVerticalPadding: 20,
  iconToolTipArrowLeft: 2.5,
  iconToolTipArrowTop: 32,
  iconToolTipBoxWidth: 300,
  iconToolTipTop: 36,
  dateBoxHorizontalPadding: 12,
  BackgroundOverlayOpacity: 0.3,
  selectWidth: 225,
  selectMobileWidth: 175,
  selectPadding: 2,
  cartListItemDescriptionSize: 11,
  mobileTablePadding: 12,
  mobileTablePaddingBottom: 6,
  mobileLabelVerticalPadding: 10,
  mobileLabelPaddingRight: 35,
  mobileLabelVerticalPaddingMobile: 8,
  mobileLabelPaddingRightMobile: 20,
  menuListItemIconSize: 16,
  priceIndicatorRotate: 1,
  priceRotate: 2.5,
  priceSplashHorizontalPadding: 10,
  priceVariantBadgeSize: 48,
  buttonWrapperMinWidth: 120,
  buttonChildGap: 12,
  buttonChildSmallGap: 8,
  buttonChildExtraSmallGap: 4,
  buttonBadgeTopPosition: -3,
  buttonBadgeRightPosition: -4,
  buttonBadgePadding: 6,
  buttonBadgePaddingSmall: 2,
  buttonBadgeFontSize: 11,
  navHeaderHeight: 81,
  navHeaderHeightSmall: 64,
  searchModalZIndex: 900,
  searchBarHorizontalPadding: 12,
  headerBreakpoint: 991,
  zipCodeInputSize: 48,
  zipCodeInputSizeSmall: 40,
  tooltipMinWidth: 80,
  toolTipTop: 35,
  toolTipArrowMarginTop: -5,
  toolTipBackground: 'rgba(0,0,0,.7)',
  toolTipArrowBorderWidth: 5,
  searchListItemGridTemplateColumns: 25,
  MarkingWrapperGridGap: 2,
  InputWithIconPaddingRight: 45,
  navMainLinkWidth: 105,
  maxHeightFaderHeight: 50,
  paginationButtonWidth: 44,
  cartCardImageSize: 48,
  toolTipCloseSize: 20,
  couponContainerHeight: 43,
  couponButtonContainer: 102,
  couponContainerPadding: 10,
  selectButtonWidth: 169
};
var palette = {
  // pallette same as brand colors
  primary: '#FFE522',
  secondary: '#0069AE',
  // brand colors
  brandYellow: '#FFE522',
  brandBlue: '#0069AE',
  brandPurple: '#A71680',
  brandPrio: '#a80073',
  // shades
  yellowLighter: '#FFFBE7',
  yellowLight: '#FFF7D1',
  blueLight: '#ECF7FE',
  blueLighter: '#D3EDFD',
  blueMedium: '#92B9D3',
  greenLight: '#F2FDF2',
  greenMedium: '#BEE5BE',
  redLight: '#FCE9E9',
  // recipeTags
  recipeVego: '#65DB69',
  recipeLactose: '#8CCDF0',
  recipeGluten: '#D5642A',
  // link same as alert blue
  link: '#0072BB',
  // black / white
  white: '#FFFFFF',
  black: '#000000',
  // grayscale
  lightest: '#F7F7F7',
  lighter: '#F1F1F1',
  light: '#E8E8E8',
  medium: '#DBDBDB',
  mediumDark: '#6C6C6C',
  dark: '#979797',
  darker: '#4A4A4A',
  darkest: '#333333',
  buttonGray: '#E5E4E5',
  disabledGray: '#B8B8B8',
  disabledDarkGray: '#5c5c5c',
  placeholder: '#8f8f8f',
  border: '#0069AE',
  boxShadow: '#E1E1E1',
  boxShadowActive: 'rgba(7, 52, 99, 0.15)',
  // Alerts
  alertRed: '#E02721',
  alertBlue: '#0072BB',
  alertGreen: '#3F9A3C',
  // overlay
  darkOverlay: 'rgba(0, 0, 0, 0.6)',
  // transparent
  transparent: '#ffffff00',
  // hover
  brandBlueHover: '#005C99',
  brandYellowHover: '#F5D800',
  brandPrioHover: '#90136F',
  brandBlueActive: '#004D80',
  brandYellowActive: '#DBC100',
  brandPrioActive: '#7A105E',
  none: 'none'
};
var spacings = {
  xxxs: 2,
  xxs: 4,
  xxs2: 6,
  xs: 8,
  xs2: 12,
  sm: 16,
  sm2: 20,
  md: 24,
  lg: 32,
  xl: 40,
  xxl: 56 // More in figma, but talk with Johan to generalize it more.
  // xxx: 72, 88, 120, 152 ?

};
var typography = {
  type: {
    primary: '"Poppins", "Helvetica Neue", Helvetica, Arial, sans-serif',
    display: '"Dom Casual"',
    code: '"SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace'
  },
  weight: {
    regular: '400',
    medium: '500',
    semiBold: '600',
    bold: '700'
  },
  size: {
    // xs all from 0-10
    xs: 10,
    // s all from 11-20
    s1: 12,
    s2: 13,
    s3: 15,
    s4: 18,
    // m all from 21-40
    m1: 24,
    m2: 30,
    // l all from 41 >
    l1: 41,
    code: 90
  },
  lineHeight: {
    // xs all from 0-15
    xs: 15,
    // s all from 16-20
    s1: 18,
    s2: 19,
    // m all from 21-40
    m1: 22,
    m2: 27,
    m3: 36,
    // l all from 41 >
    l1: 45
  }
};
var animations = {
  tapScale: 0.9,
  hoverScale: 1.1,
  buttonTransition: 'all 250ms cubic-bezier(0.165, 0.84, 0.44, 1)',
  rippleTransition: '750ms cubic-bezier(0.19, 1, 0.22, 1)',
  saveButtonAnimationComplete: 600
};

var createTheme = function createTheme(_a) {
  var palette = _a.palette,
      typography = _a.typography,
      attributes = _a.attributes,
      breakpoints = _a.breakpoints,
      spacings = _a.spacings,
      constants = _a.constants,
      animations = _a.animations;
  return {
    palette: palette,
    typography: typography,
    attributes: attributes,
    breakpoints: breakpoints,
    spacings: spacings,
    constants: constants,
    animations: animations
  };
};

var theme = createTheme({
  palette: palette,
  typography: typography,
  attributes: attributes,
  breakpoints: breakpoints,
  spacings: spacings,
  constants: constants,
  animations: animations
}); // @TODO check responsive sizes, for desktop and mobile. Check with Johan

var H1$1 = styled.h1(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  text-decoration: ", ";\n  color: ", ";\n  font-weight: ", ";\n\n  font-size: ", "px;\n  line-height: ", "px;\n\n  @media (min-width: ", "px) {\n    font-size: ", "px;\n    line-height: ", "px;\n  }\n"], ["\n  text-decoration: ", ";\n  color: ", ";\n  font-weight: ", ";\n\n  font-size: ", "px;\n  line-height: ", "px;\n\n  @media (min-width: ", "px) {\n    font-size: ", "px;\n    line-height: ", "px;\n  }\n"])), function (props) {
  return props.lineThrough ? 'line-through' : 'none';
}, function (props) {
  var _a;

  return props.fontColor ? props.fontColor : (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.black;
}, function (props) {
  var _a, _b;

  return (_a = props.fontWeight) !== null && _a !== void 0 ? _a : (_b = props.theme.typography) === null || _b === void 0 ? void 0 : _b.weight.bold;
}, function (props) {
  var _a;

  return (_a = props.theme.typography) === null || _a === void 0 ? void 0 : _a.size.m1;
}, function (props) {
  var _a;

  return (_a = props.theme.typography) === null || _a === void 0 ? void 0 : _a.lineHeight.l1;
}, function (props) {
  var _a;

  return (_a = props.theme.breakpoints) === null || _a === void 0 ? void 0 : _a.sm;
}, function (props) {
  var _a;

  return (_a = props.theme.typography) === null || _a === void 0 ? void 0 : _a.size.m2;
}, function (props) {
  var _a;

  return (_a = props.theme.typography) === null || _a === void 0 ? void 0 : _a.lineHeight.l1;
});
var templateObject_1$4;

var H1 = function H1(_a) {
  var _b;

  var children = _a.children,
      lineThrough = _a.lineThrough,
      color = _a.color,
      fontWeight = _a.fontWeight,
      props = __rest(_a, ["children", "lineThrough", "color", "fontWeight"]);

  return React.createElement(H1$1, _assign({
    lineThrough: lineThrough,
    fontColor: color,
    fontWeight: fontWeight && theme && ((_b = theme.typography) === null || _b === void 0 ? void 0 : _b.weight) && theme.typography.weight[fontWeight]
  }, props), children);
}; // @TODO check responsive sizes, for desktop and mobile. Check with Johan


var H2$1 = styled.h2(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  text-decoration: ", ";\n  color: ", ";\n  font-weight: ", ";\n\n  font-size: ", "px;\n  line-height: ", "px;\n\n  @media (max-width: ", "px) {\n    font-size: ", "px;\n    line-height: ", "px;\n  }\n"], ["\n  text-decoration: ", ";\n  color: ", ";\n  font-weight: ", ";\n\n  font-size: ", "px;\n  line-height: ", "px;\n\n  @media (max-width: ", "px) {\n    font-size: ", "px;\n    line-height: ", "px;\n  }\n"])), function (props) {
  return props.lineThrough ? 'line-through' : 'none';
}, function (props) {
  var _a;

  return props.fontColor ? props.fontColor : (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.black;
}, function (props) {
  var _a, _b;

  return (_a = props.fontWeight) !== null && _a !== void 0 ? _a : (_b = props.theme.typography) === null || _b === void 0 ? void 0 : _b.weight.semiBold;
}, function (props) {
  var _a;

  return (_a = props.theme.typography) === null || _a === void 0 ? void 0 : _a.size.s4;
}, function (props) {
  var _a;

  return (_a = props.theme.typography) === null || _a === void 0 ? void 0 : _a.lineHeight.m2;
}, function (props) {
  var _a;

  return (_a = props.theme.breakpoints) === null || _a === void 0 ? void 0 : _a.sm;
}, function (props) {
  var _a;

  return (_a = props.theme.typography) === null || _a === void 0 ? void 0 : _a.size.s3;
}, function (props) {
  var _a;

  return (_a = props.theme.typography) === null || _a === void 0 ? void 0 : _a.lineHeight.m2;
});
var templateObject_1$3;

var H2 = function H2(_a) {
  var _b;

  var children = _a.children,
      lineThrough = _a.lineThrough,
      color = _a.color,
      fontWeight = _a.fontWeight,
      props = __rest(_a, ["children", "lineThrough", "color", "fontWeight"]);

  return React.createElement(H2$1, _assign({
    lineThrough: lineThrough,
    fontColor: color,
    fontWeight: fontWeight && theme && ((_b = theme.typography) === null || _b === void 0 ? void 0 : _b.weight) && theme.typography.weight[fontWeight]
  }, props), children);
}; // @TODO check responsive sizes, for desktop and mobile. Check with Johan


var H3$1 = styled.h3(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  text-decoration: ", ";\n  color: ", ";\n  font-weight: ", ";\n  font-size: ", "px;\n  line-height: ", "px;\n"], ["\n  text-decoration: ", ";\n  color: ", ";\n  font-weight: ", ";\n  font-size: ", "px;\n  line-height: ", "px;\n"])), function (props) {
  return props.lineThrough ? 'line-through' : 'none';
}, function (props) {
  var _a;

  return props.fontColor ? props.fontColor : (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.black;
}, function (props) {
  var _a, _b;

  return (_a = props.fontWeight) !== null && _a !== void 0 ? _a : (_b = props.theme.typography) === null || _b === void 0 ? void 0 : _b.weight.semiBold;
}, function (props) {
  var _a;

  return (_a = props.theme.typography) === null || _a === void 0 ? void 0 : _a.size.s3;
}, function (props) {
  var _a;

  return (_a = props.theme.typography) === null || _a === void 0 ? void 0 : _a.lineHeight.m1;
});
var templateObject_1$2;

var H3 = function H3(_a) {
  var _b;

  var children = _a.children,
      lineThrough = _a.lineThrough,
      color = _a.color,
      fontWeight = _a.fontWeight,
      props = __rest(_a, ["children", "lineThrough", "color", "fontWeight"]);

  return React.createElement(H3$1, _assign({
    lineThrough: lineThrough,
    fontColor: color,
    fontWeight: fontWeight && theme && ((_b = theme.typography) === null || _b === void 0 ? void 0 : _b.weight) && theme.typography.weight[fontWeight]
  }, props), children);
};

var TextSize;

(function (TextSize) {
  TextSize["REGULAR"] = "regular";
  TextSize["SMALL"] = "small";
  TextSize["EXTRASMALL"] = "extrasmall";
  TextSize["TINY"] = "tiny";
})(TextSize || (TextSize = {}));

var textTypes =
/*#__PURE__*/
Object.freeze({
  __proto__: null,

  get TextSize() {
    return TextSize;
  }

});

var determineTextSize = function determineTextSize(size, theme) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;

  switch (size) {
    case TextSize.TINY:
      return "\n        font-size: ".concat(theme && ((_b = (_a = theme.typography) === null || _a === void 0 ? void 0 : _a.size) === null || _b === void 0 ? void 0 : _b.xs), "px;\n        line-height: ").concat(theme && ((_d = (_c = theme.typography) === null || _c === void 0 ? void 0 : _c.lineHeight) === null || _d === void 0 ? void 0 : _d.xs), "px;\n      ");

    case TextSize.SMALL:
      return "\n        font-size: ".concat(theme && ((_f = (_e = theme.typography) === null || _e === void 0 ? void 0 : _e.size) === null || _f === void 0 ? void 0 : _f.s2), "px;\n        line-height: ").concat(theme && ((_h = (_g = theme.typography) === null || _g === void 0 ? void 0 : _g.lineHeight) === null || _h === void 0 ? void 0 : _h.s2), "px;\n      ");

    case TextSize.EXTRASMALL:
      return "\n        font-size: ".concat(theme && ((_k = (_j = theme.typography) === null || _j === void 0 ? void 0 : _j.size) === null || _k === void 0 ? void 0 : _k.s1), "px;\n        line-height: ").concat(theme && ((_m = (_l = theme.typography) === null || _l === void 0 ? void 0 : _l.lineHeight) === null || _m === void 0 ? void 0 : _m.s1), "px;\n      ");

    case TextSize.REGULAR:
    default:
      return "\n        font-size: ".concat(theme && ((_p = (_o = theme.typography) === null || _o === void 0 ? void 0 : _o.size) === null || _p === void 0 ? void 0 : _p.s3), "px;\n        line-height: ").concat(theme && ((_r = (_q = theme.typography) === null || _q === void 0 ? void 0 : _q.lineHeight) === null || _r === void 0 ? void 0 : _r.m1), "px;\n      ");
  }
};

var BodyText$1 = styled.p(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  ", ";\n  font-weight: ", ";\n  color: ", ";\n  text-decoration: ", ";\n  text-align: ", ";\n"], ["\n  ", ";\n  font-weight: ", ";\n  color: ", ";\n  text-decoration: ", ";\n  text-align: ", ";\n"])), function (props) {
  return determineTextSize(props.size, props.theme);
}, function (props) {
  var _a, _b;

  return (_a = props.fontWeight) !== null && _a !== void 0 ? _a : (_b = props.theme.typography) === null || _b === void 0 ? void 0 : _b.weight.regular;
}, function (props) {
  var _a;

  return props.fontColor ? props.fontColor : (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.black;
}, function (props) {
  return props.lineThrough ? 'line-through' : 'none';
}, function (props) {
  return props.textAlign || 'left';
});
var templateObject_1$1;

var BodyText = function BodyText(_a) {
  var _b;

  var _c = _a.size,
      size = _c === void 0 ? TextSize.REGULAR : _c,
      _d = _a.color,
      color = _d === void 0 ? 'black' : _d,
      children = _a.children,
      lineThrough = _a.lineThrough,
      fontWeight = _a.fontWeight,
      textAlign = _a.textAlign,
      props = __rest(_a, ["size", "color", "children", "lineThrough", "fontWeight", "textAlign"]);

  return React.createElement(BodyText$1, _assign({
    size: size,
    fontColor: color,
    lineThrough: lineThrough,
    fontWeight: fontWeight && theme && ((_b = theme.typography) === null || _b === void 0 ? void 0 : _b.weight) && theme.typography.weight[fontWeight],
    textAlign: textAlign
  }, props), children);
};

var LinkText$1 = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n\n  font-weight: ", ";\n"], ["\n  ", "\n\n  font-weight: ", ";\n"])), function (props) {
  return determineTextSize(props.size, props.theme);
}, function (props) {
  var _a, _b;

  return (_a = props.fontWeight) !== null && _a !== void 0 ? _a : (_b = props.theme.typography) === null || _b === void 0 ? void 0 : _b.weight.medium;
});
var templateObject_1;

var LinkText = function LinkText(_a) {
  var _b = _a.size,
      size = _b === void 0 ? TextSize.REGULAR : _b,
      onClick = _a.onClick,
      children = _a.children,
      props = __rest(_a, ["size", "onClick", "children"]);

  return React.createElement(LinkText$1, _assign({
    onClick: onClick,
    size: size
  }, props), children);
};

export { BodyText, H1, H2, H3, H3$1 as H3Styles, LinkText, textTypes as TextTypes };